import { render, staticRenderFns } from "./invite-rules.vue?vue&type=template&id=0c709341&scoped=true&"
import script from "./invite-rules.vue?vue&type=script&lang=js&"
export * from "./invite-rules.vue?vue&type=script&lang=js&"
import style0 from "./invite-rules.vue?vue&type=style&index=0&id=0c709341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c709341",
  null
  
)

export default component.exports